export default __webpack_public_path__ + "static/media/ic6.d688561c.gif";